'use strict';

require('../../style/css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/modal/style/css.js
// module id = 368
// module chunks = 125